import React, { useState } from 'react';
import { FiClock, FiUsers } from 'react-icons/fi';
import Toggle from '../../../Toggle';
import { ClickCard, DescriptionField, LinkFormProps, PasteLinkCard, SmallField, TitleField, useLinkForm } from './LinkCards';

const EXTRAS = [
    { key: 'calendar', title: 'Show an “Add to calendar” button', hint: 'Google, Outlook and Apple calendar' },
    { key: 'reminder', title: 'Email a reminder to registered investors the day before', hint: 'Uses the Event invitation template' },
    { key: 'recording', title: 'Swap the link for the recording when I add it', hint: 'The card changes from “Register” to “Watch the recording”' },
];

// Add a webinar: registration link, date & presenter, reminders and the swap to the recording (spec 420:13595)
const WebinarForm: React.FC<LinkFormProps> = props => {
    const form = useLinkForm('webinar', props, 'tab');
    const [extras, setExtras] = useState<Record<string, boolean>>(() => Object.fromEntries(EXTRAS.map(x => [x.key, true])));

    return <>
        <PasteLinkCard icon={<FiUsers />} form={form} placeholder="https://… the Zoom, Teams or webinar registration link">
            <TitleField value={props.title} onChange={props.onTitle} />
            <div className="fields three hub-news-fields">
                <SmallField label="Date & time" value={form.fields[0]} onChange={v => form.setField(0, v)} />
                <SmallField label="Presenter" value={form.fields[1]} onChange={v => form.setField(1, v)} />
                <SmallField label="Length" hint="(optional)" value={form.fields[2]} onChange={v => form.setField(2, v)} />
            </div>
            <DescriptionField value={form.description} onChange={form.setDescription} />
        </PasteLinkCard>
        <ClickCard form={form} newTab="Open the registration page in a new tab" />
        <section className="card hub-news-form">
            <div className="section-title">
                <span className="icon-tile"><FiClock /></span>
                <div className="text"><h2>Before and after the webinar</h2><div className="hint">Investi can do these for you</div></div>
            </div>
            <div className="hub-news-toggles">
                {EXTRAS.map(x => <div key={x.key} className="setting-row">
                    <div className="text"><div className="title">{x.title}</div><div className="hint">{x.hint}</div></div>
                    <Toggle label={x.title} checked={extras[x.key]} onChange={v => setExtras(s => ({ ...s, [x.key]: v }))} />
                </div>)}
            </div>
        </section>
    </>;
};

export default WebinarForm;
